import { render, staticRenderFns } from "./CorrectPayRangeVersionModal.vue?vue&type=template&id=183e7f33&scoped=true"
import script from "./CorrectPayRangeVersionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CorrectPayRangeVersionModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CorrectPayRangeVersionModal.vue?vue&type=style&index=0&id=183e7f33&prod&scoped=true&lang=css"
import style1 from "./CorrectPayRangeVersionModal.vue?vue&type=style&index=1&id=183e7f33&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e7f33",
  null
  
)

export default component.exports